export const API_BASE_URL = 'https://frog02-22287.wykr.es';
